// This import loads the firebase namespace along with all its type information.
import CheckoutSession from './checkout-session-model'

export async function load_checkoutSessions(): Promise<CheckoutSession[]> {
  throw 'Not implemented'
}

export async function delete_checkoutSession(): Promise<boolean> {
  throw 'Not implemented'
}

export async function store_checkoutSession(): Promise<CheckoutSession> {
  throw 'Not implemented'
}
